// export let currentState = '';

export function changeUploadBoxState(state) {
    if(state == undefined){
        this.uploadBoxState = null;
        // currentState = this.uploadBoxState;
        return;
    }
    if(state.length == undefined){
        this.uploadBoxState = null;
        // currentState = this.uploadBoxState;
        return;
    }
    this.uploadBoxState = state;
    // currentState = this.uploadBoxState;

    return;
}


const definitions = function() {
    let definitions = new Map();

    definitions.set('provider-logo', {
        ratio: '1:1',
        type: 'file_meta_data_image'
    });
    definitions.set('tour-logo', {
        ratio: '1:1',
        type: 'file_meta_data_image'
    });
    definitions.set('tour-image', {
        ratio: '1:1',
        type: 'file_meta_data_image'
    });
    definitions.set('provider-info-images', {
        ratio: '4:3',
        type: 'file_meta_data_image'
    });
    definitions.set('audio-feature-preview', {
        ratio: '9:16',
        type: 'file_meta_data_image'
    });
    definitions.set('ar-feature-preview', {
        ratio: '1:1',
        type: 'file_meta_data_image'
    });
    definitions.set('ar-object-image', {
        ratio: '1:1',
        type: 'file_meta_data_image'
    });
    definitions.set('gallery-image', {
        ratio: '16:9, 9:16',
        type: 'file_meta_data_image'
    });
    definitions.set('gallery-thumbnail', {
        ratio: '16:9, 9:16',
        type: 'file_meta_data_image'
    });
    definitions.set('station-image', {
        ratio:  '4:3 or 1:1 (horizontal view), 8:3 (vertical view)',
        type: 'file_meta_data_image'
    });
    definitions.set('station-logo', {
        ratio:  '1:1',
        type: 'file_meta_data_image'
    });
    definitions.set('panorama-image', {
        ratio:  '1:1',
        type: 'file_meta_data_image'
    });

    return definitions;
}
export const fileDefinition = definitions();

export const fileTypes = ['image', 'audio', 'video', 'panorama_image', 'panorama_video', 'chroma_video', 'three_dimensional_object', 'marker', 'waypoints'];


export function selectFileFromMediaLibrary(file) {

    const { path:filePath, id:fileId, copyright_text, copyright_link } = file;

    if(this.uploadBoxState == 'gallery_image')
    {
        this.gallery_form.loaded_file_path = filePath;
        this.gallery_form.from_media_library_id = fileId;
        this.changeUploadBoxState();
    }
    if(this.uploadBoxState == 'gallery_image_update')
    {
        this.gallery_update_item_form.loaded_file_path = filePath;
        this.gallery_update_item_form.from_media_library_id = fileId;
        this.changeUploadBoxState();
    }
    //use only in station component
    if( ['preview_file', 'logo_file'].includes(this.uploadBoxState) )
    {
    	if( this.form.hasOwnProperty('station_files') )
    	{
            //Validate Station Logo/Preview image existing Language
            if(this.$page.props.tour.data.fallback_language != this.form.current_language &&
                this.$page.props.station.data.logo == null && this.uploadBoxState == 'logo_file')
            {
                this.errors.logo_file = 'You need to add Logo File in Fallback language first';
                this.changeUploadBoxState();
                return;
            }
            if(this.$page.props.tour.data.fallback_language != this.form.current_language &&
                this.$page.props.station.data.image == null && this.uploadBoxState == 'preview_file')
            {
                this.errors.preview_file = 'You need to add Preview File in Fallback language first';
                this.changeUploadBoxState();
                return;
            }
            //==End validation

    		this.form.station_files[this.uploadBoxState].loaded_file_path = filePath;
	        this.form.station_files[this.uploadBoxState].from_media_library_id = fileId;
	        this.changeUploadBoxState();
    	}
    }
    //use only in tour component
    if( ['preview_file', 'logo_file'].includes(this.uploadBoxState) )
    {
    	if( this.form.hasOwnProperty('tour_files') )
    	{
            //Validate Tour Logo/Preview image existing Language
            if(this.$page.props.tour.data.fallback_language != this.form.current_language &&
                this.$page.props.tour.data.logo == null && this.uploadBoxState == 'logo_file')
            {
                this.errors.logo_file = 'You need to add Logo File in Fallback language first';
                this.changeUploadBoxState();
                return;
            }
            if(this.$page.props.tour.data.fallback_language != this.form.current_language &&
                this.$page.props.tour.data.image == null && this.uploadBoxState == 'preview_file')
            {
                this.errors.preview_file = 'You need to add Preview File in Fallback language first';
                this.changeUploadBoxState();
                return;
            }
            //==End validation

    		this.form.tour_files[this.uploadBoxState].loaded_file_path = filePath;
	        this.form.tour_files[this.uploadBoxState].from_media_library_id = fileId;
	        this.changeUploadBoxState();
    	}
    }
    // Waypoints ( GPX data )
    if(this.uploadBoxState == 'waypoints')
    {
        this.coordinates_data_form.coordinates_data.loaded_file_path = filePath;
        this.coordinates_data_form.coordinates_data.from_media_library_id = fileId;
        this.saveCoordinatesData();
        this.changeUploadBoxState();
    }
    // MediaLibrary box inside features
    // Panorama feature
    if(['panorama_file_image', 'panorama_file_video'].includes(this.uploadBoxState))
    {
        this.feature_panorama_form.feature_files.panorama_files.languages[this.feature_panorama_form.current_language]
        .loaded_file_path = filePath;
        this.feature_panorama_form.feature_files.panorama_files.languages[this.feature_panorama_form.current_language]
        .from_media_library_id = fileId;
        this.changeUploadBoxState();
    }
    if(this.uploadBoxState == 'panorama_feature_audio')
    {
        this.feature_panorama_form.feature_files.audio_files.languages[this.feature_panorama_form.current_language]
        .loaded_file_path = filePath;
        this.feature_panorama_form.feature_files.audio_files.languages[this.feature_panorama_form.current_language]
        .from_media_library_id = fileId;
        this.changeUploadBoxState();
    }
    // Audioguide feature
    if(this.uploadBoxState == 'audio_feature_audio')
    {
        this.feature_audioguide_form.feature_audio_files[this.feature_audioguide_form.current_language]
        .loaded_file_path = filePath;
        this.feature_audioguide_form.feature_audio_files[this.feature_audioguide_form.current_language]
        .from_media_library_id = fileId;
        this.feature_audioguide_form.feature_audio_files[this.feature_audioguide_form.current_language]
        .copyright_text = copyright_text;
        this.feature_audioguide_form.feature_audio_files[this.feature_audioguide_form.current_language]
        .copyright_link = copyright_link;
        this.changeUploadBoxState();
    }
    if(this.uploadBoxState == 'audio_feature_background_image')
    {
        this.feature_audioguide_form.feature_audio_preview_images[this.feature_audioguide_form.current_language]
        .loaded_file_path = filePath;
        this.feature_audioguide_form.feature_audio_preview_images[this.feature_audioguide_form.current_language]
        .from_media_library_id = fileId;
        this.feature_audioguide_form.feature_audio_preview_images[this.feature_audioguide_form.current_language]
        .copyright_text = copyright_text;
        this.feature_audioguide_form.feature_audio_preview_images[this.feature_audioguide_form.current_language]
        .copyright_link = copyright_link;
        this.changeUploadBoxState();
    }
    //video feature
    if(this.uploadBoxState == 'video_feature_video')
    {
        this.feature_video_form.feature_video_files.languages[this.feature_video_form.current_language].loaded_file_path = filePath;
        this.feature_video_form.feature_video_files.languages[this.feature_video_form.current_language].from_media_library_id = fileId;
        this.changeUploadBoxState();
    }
    // ar-feature
    if(this.uploadBoxState == 'augmented_reality_feature_glb')
    {
        this.feature_augmented_reality_form.languages[this.feature_augmented_reality_form.current_language]
        .glb_file = filePath;
        this.changeUploadBoxState();
    }
    if(this.uploadBoxState == 'augmented_reality_feature_usdz')
    {
        this.feature_augmented_reality_form.languages[this.feature_augmented_reality_form.current_language]
        .usdz_file = filePath;
        this.changeUploadBoxState();
    }
    if(this.uploadBoxState == 'augmented_reality_feature_marker')
    {
        this.feature_augmented_reality_form.general.marker_file = filePath;
        this.changeUploadBoxState();
    }
    if(this.uploadBoxState == 'augmented_reality_feature_audio')
    {
        this.feature_augmented_reality_form.languages[this.feature_augmented_reality_form.current_language]
        .audio_file = filePath;
        this.changeUploadBoxState();
    }
    //use for change Providers logo in My Area
    if(this.uploadBoxState == 'providers_logo')
    {
        this.form.logo_file.loaded_file_path = filePath;
        this.form.logo_file.from_media_library_id = fileId;
        this.changeUploadBoxState();
    }
return
}

export function fileSizeMaximumValue(uploadBoxType){
    switch(uploadBoxType){
    case 'image':
        return 4;
    case 'audio':
        return 7;
    case 'video':
        return 40;
    case 'panorama_image':
        return 4;
    case 'panorama_video':
        return 40;
    case 'chroma_video':
        return 40;
    case 'three_dimensional_object_glb':
        return 35;
    case 'three_dimensional_object_usdz':
        return 35;
    case 'marker':
        return 4;
    case 'waypoints':
        return 1;
    }
}